import './App.css';
import React from 'react';
import Route from './Router';
import logo from './assets/Boltum.png'


const App = () => {
  return (
    <div className='AppGral'>   
      <Route/>
    </div>
  );
}

export default App;
